import { combineReducers } from 'redux';

const crumb = (state = '') => {
    const nextState = state;

    return nextState;
};

const domain = (state = '') => {
    const nextState = state;

    return nextState;
};

const eid = (state = '') => {
    const nextState = state;

    return nextState;
};

const locale = (state = '') => {
    const nextState = state;

    return nextState;
};

const referer = (state = '/') => {
    const nextState = state;

    return nextState;
};

const tld = (state = '') => {
    const nextState = state;

    return nextState;
};

const defaultCurrency = (state = '') => {
    const nextState = state;

    return nextState;
};

const currencyFormat = (state = '') => {
    const nextState = state;

    return nextState;
};

export default combineReducers({
    crumb,
    domain,
    eid,
    locale,
    referer,
    tld,
    defaultCurrency,
    currencyFormat,
});
